import React from 'react';
import { Link } from 'react-router-dom';
import { createPageUrl } from '../utils';
import { 
  Bot, UserPlus, XCircle, FileText, Download, Calendar, 
  Folder, FileEdit, BarChart3, Users, CalendarCheck, 
  StickyNote, Briefcase, Bell, MessageSquare, List, 
  CheckSquare, Search, BellOff, Clipboard, FileStack,
  MessageCircle
} from 'lucide-react';
import { Card } from '../Components/ui/card';

export default function Tools() {
  const tools = [
    { name: 'AI Agents', icon: Bot, page: 'AIAgents', color: 'from-purple-500 to-purple-600' },
    { name: 'Add Interviewer', icon: UserPlus, page: 'AddInterviewer', color: 'from-blue-500 to-blue-600' },
    { name: 'Blacklist', icon: XCircle, page: 'Blacklist', color: 'from-red-500 to-red-600' },
    { name: 'Consent Details', icon: FileText, page: 'ConsentDetails', color: 'from-green-500 to-green-600' },
    { name: 'Download Center', icon: Download, page: 'DownloadCenter', color: 'from-cyan-500 to-cyan-600' },
    { name: 'Event Calendar', icon: Calendar, page: 'EventCalendar', color: 'from-orange-500 to-orange-600' },
    { name: 'Files', icon: Folder, page: 'Files', color: 'from-yellow-500 to-yellow-600' },
    { name: 'Form Templates', icon: FileEdit, page: 'FormTemplates', color: 'from-pink-500 to-pink-600' },
    { name: 'CERPAI BI', icon: BarChart3, page: 'CerpaiBI', color: 'from-indigo-500 to-indigo-600' },
    { name: 'Groups', icon: Users, page: 'Groups', color: 'from-teal-500 to-teal-600' },
    { name: 'Interview Schedules', icon: CalendarCheck, page: 'InterviewSchedules', color: 'from-blue-500 to-blue-600' },
    { name: 'Notes List', icon: StickyNote, page: 'NotesList', color: 'from-amber-500 to-amber-600' },
    { name: 'Published Jobs', icon: Briefcase, page: 'PublishedJobs', color: 'from-green-500 to-green-600' },
    { name: 'Release Notes', icon: Bell, page: 'ReleaseNotes', color: 'from-purple-500 to-purple-600' },
    { name: 'SMS Dashboard', icon: MessageSquare, page: 'SMSDashboard', color: 'from-blue-500 to-blue-600' },
    { name: 'Snap List', icon: List, page: 'SnapList', color: 'from-cyan-500 to-cyan-600' },
    { name: 'Task Manager', icon: CheckSquare, page: 'TaskManager', color: 'from-red-500 to-red-600' },
    { name: 'Advanced Search', icon: Search, page: 'AdvancedSearch', color: 'from-indigo-500 to-indigo-600' },
    { name: 'Unsubscribe List', icon: BellOff, page: 'UnsubscribeList', color: 'from-gray-500 to-gray-600' },
    { name: 'View Clipboard', icon: Clipboard, page: 'ViewClipboard', color: 'from-orange-500 to-orange-600' },
    { name: 'Submissions', icon: FileStack, page: 'Submissions', color: 'from-blue-500 to-blue-600' },
    { name: 'Message Center', icon: MessageCircle, page: 'MessageCenter', color: 'from-green-500 to-green-600' }
  ];

  return (
    <div className="max-w-[1600px] mx-auto">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Tools & Features</h1>
        <p className="text-sm text-gray-500">Access all recruitment tools and utilities</p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4">
        {tools.map((tool) => {
          const Icon = tool.icon;
          return (
            <Link key={tool.name} to={createPageUrl(tool.page)}>
              <Card className="hover:shadow-lg transition-all duration-300 border border-gray-200 cursor-pointer group h-full">
                <div className="p-4 flex flex-col items-center justify-center text-center space-y-3 h-full">
                  <div className={`p-3 rounded-xl bg-gradient-to-br ${tool.color} group-hover:scale-110 transition-transform duration-300`}>
                    <Icon className="h-6 w-6 text-white" />
                  </div>
                  <h3 className="text-xs font-medium text-gray-900 group-hover:text-blue-600 transition-colors leading-tight">
                    {tool.name}
                  </h3>
                </div>
              </Card>
            </Link>
          );
        })}
      </div>
    </div>
  );
}